export function CopyIcon(props) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.6417 13.1V4.64173H13.1V13.1H4.6417ZM4.4917 14C4.07749 14 3.7417 13.6642 3.7417 13.25V4.49173C3.7417 4.07752 4.07749 3.74173 4.4917 3.74173H13.25C13.6642 3.74173 14 4.07752 14 4.49173V13.25C14 13.6642 13.6642 14 13.25 14H4.4917Z"
        fill={props.color || "#4E4E4E"}
      />
      <path
        d="M2.89996 11.3C2.89996 11.5485 2.6985 11.75 2.44998 11.75C2.20146 11.75 2 11.5485 2 11.3V2.75C2 2.33579 2.33579 2 2.75 2H11.3C11.5485 2 11.75 2.20147 11.75 2.45C11.75 2.69854 11.5485 2.90001 11.3 2.90001H3.27496C3.06786 2.90001 2.89996 3.0679 2.89996 3.27501V11.3Z"
        fill={props.color || "#4E4E4E"}
      />
    </svg>
  );
}

export function TickIcon(props) {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.69269 8.80775C4.95809 9.06408 5.38839 9.06408 5.65378 8.80776L10.6302 4.12048C10.8956 3.86415 10.8956 3.44857 10.6302 3.19224C10.3648 2.93592 9.93449 2.93592 9.6691 3.19224L5.6538 6.95127C5.3884 7.20759 4.95811 7.20759 4.69271 6.95127L3.16014 5.527C2.89474 5.27068 2.46445 5.27068 2.19905 5.527C1.93365 5.78333 1.93365 6.19891 2.19904 6.45524L4.69269 8.80775Z"
        fill={props.color || "#4E4E4E"}
      />
    </svg>
  );
}
